// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main-container .visible{opacity:1;transition:opacity 1s;transition-delay:.1s}.main-container .fixed-btn-booking{bottom:0;position:fixed;width:100%;z-index:10}@media (min-width:1024px){.main-container .fixed-btn-booking{display:none}}.main-container .fixed-btn-booking a,.main-container .fixed-btn-booking button{align-items:center;display:flex;height:60px;justify-content:center;width:50%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
